import React from 'react';
import {useStyles} from "../miscellaneous/constants";
import {makeStyles} from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SortedTable from "../miscellaneous/SortedTable";
import clsx from 'clsx';
import {bestBoundWithTimeLimit} from "../miscellaneous/functionsCOP";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import BoundsEvolution from "./BoundsEvolution";
import {isFiltered, numberWithSpaces} from "../miscellaneous/functions";
import Title from "../miscellaneous/Title";




const tableStyles = makeStyles({
    best: {
        color: "#61C04C"
    },
    conflict: {
        color: "#ffe7e4",
    },
    onright: {
        display: "flex",
        justifyContent: "space-between"
    },
    hd: {
        backgroundColor: "lightgrey",
        position: "sticky",
        top: "63px",
        zIndex: 10,
    },

    over: {
        overflow: "initial"
    },
    table: {
        position: "relative"
    },
    tabs: {
        position: "sticky",
        top: "63px",
        zIndex: 11,
        marginBottom: "-6px!important",
        backgroundColor: "white"

    }

})

export default function BenchmarksCOP(props) {
    const classes = tableStyles()
    const globalclasses = useStyles();

    // For tabs
    const [activeTab, setActiveTab] = React.useState(0);

    const [detailID, setDetailID] = React.useState(-1)

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    // For Modal
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
        setDetailID(-1)
    };

    function handleClick(e, id) {
        e.preventDefault()
        setOpen(true)
        setDetailID(id)
    }

    if (props.selectedSolvers.length === 0) return null;

    //let results = createResults(props.selectedSolvers, props.results, props.benchmarks, props.filters)
    let scores = props.scores//createCOPScore(props.selectedSolvers, props.results, props.benchmarks, props.filters)
    //if (results.length === 0) return null;


    let headCells = [
        {id: 'name', numeric: false, disablePadding: false, label: 'Instance'},
        {id: 'nb_variables', numeric: true, disablePadding: false, label: "|V|"},
        {id: 'nb_constraints', numeric: true, disablePadding: false, label: "|C|"},
        {id: 'type', numeric: false, disablePadding: false, label: "Optimisation"},
        {id: 'bound', numeric: true, disablePadding: false, label: "Best Bound"}
    ]

    props.selectedSolvers.forEach(s => headCells.push({
        id: s.name + " " + s.version,
        numeric: true,
        disablePadding: false,
        label: s.name + " " + s.version
    }))



    for(let r of scores) {
        r["nb_variables"] = numberWithSpaces(r["nb_variables"])
        r["nb_constraints"] = numberWithSpaces(r["nb_constraints"])
    }

    return (
        <div>
            <BoundsEvolution handleClose={handleClose} open={open} results={props.results} id={detailID} selectedSolvers={props.selectedSolvers}
                             timeLimit={props.filters.timeLimit} benchmark={props.benchmarks.filter(e => e.id === detailID)}/>

            <Paper className={clsx(globalclasses.paper, classes.over)}>
                <Title><span style={{color:'#408033'}}>Detailed Results</span></Title>
                <SortedTable tooltip={true} rows={scores.filter(item => props.filters.name.length < 3 || item.name.includes(props.filters.name))}
                             headCells={headCells} headerClasses={classes} handleClick={handleClick}/>
            </Paper>
        </div>
    )

}

//
